import { useMutation, useQueryClient } from "react-query";
import authAPI from "../authAPI";

export const useMapFeideGroup = () => {
  const queryClient = useQueryClient();

  return useMutation(
    ({ feideGroupId, organizationId, digupGroupId }) =>
      authAPI.mapFeideGroup(feideGroupId, organizationId, digupGroupId),
    {
      onSuccess: (data, variables) => {
        queryClient.invalidateQueries(["feideGroups", variables.organizationId]);
        queryClient.invalidateQueries(["group"]);
        queryClient.invalidateQueries(["organizations"]);
      },
      onError: (error) => {
        console.error("Error while mapping FEIDE group:", error);
      },
    }
  );
};
